import { render, staticRenderFns } from "./OPACIndex.vue?vue&type=template&id=954ad79c&scoped=true&"
import script from "./OPACIndex.vue?vue&type=script&lang=js&"
export * from "./OPACIndex.vue?vue&type=script&lang=js&"
import style0 from "./OPACIndex.vue?vue&type=style&index=0&id=954ad79c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954ad79c",
  null
  
)

component.options.__file = "OPACIndex.vue"
export default component.exports